import { type Trip } from '@/api/accommodation/types'
import { Typography } from '@/components/ui/typography'
import { TripCard } from './TripCard'

interface DetailTripsSectionProps {
  trips: Trip[]
}

export function DetailTripsSection({ trips }: DetailTripsSectionProps) {
  return (
    <div id="trips" className="scroll-mt-38 space-y-4 lg:scroll-mt-16">
      <div className="mb-6">
        <Typography variant="h2">Tipy na výlety v okolí</Typography>
        <p className="mt-1 text-sm text-slate-500">
          Ve spolupráci s{' '}
          <a href="https://www.kudyznudy.cz" target="_blank" rel="noopener" className="underline underline-offset-2">
            Kudy z nudy
          </a>
        </p>
      </div>
      <div className="space-y-4">
        {trips.map((trip, index) => (
          <TripCard key={index} trip={trip} />
        ))}
      </div>
    </div>
  )
}
